import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/index.tsx';
import Hero from './components/Hero/index.tsx';
import ArticleList from './components/ArticleList/index.tsx';
import TechStack from './components/TechStack/index.tsx';
import Footer from './components/Footer/index.tsx';
import ArticleDetail from './components/ArticleDetail/index.tsx';
import ArticleListPage from './components/ArticleListPage/index.tsx';
import ProjectsPage from './components/ProjectsPage/index.tsx';
import AboutPage from './components/AboutPage/index.tsx';
import Loader from './components/Loader/index.tsx';
import './App.css';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route 
            path="/" 
            element={
              <>
                <Hero />
                <ArticleList />
                <TechStack />
              </>
            } 
          />
          <Route path="/articles" element={<ArticleListPage />} />
          <Route path="/article/:id" element={<ArticleDetail />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/about" element={<AboutPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
